export const ACCOUNT_PRODUCT_GROUP = {
  CHECKING: "Checking",
  SAVINGS: "Savings",
  CREDIT_CARD: "Credit cards",
  LOAN: "Loans",
  CD: "CDs",
  EXTERNAL: "External accounts",
  UNKNOWN: "Others",
};

export const MAX_PAGE_SIZE = 250;
